import { render, staticRenderFns } from "./FormModalPatient.vue?vue&type=template&id=0d48f152&scoped=true"
import script from "./FormModalPatient.vue?vue&type=script&lang=js"
export * from "./FormModalPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48f152",
  null
  
)

export default component.exports